import axios from "axios";

export const getProductServices = async () => {
  const url = `/api/get-order-page`;
  const { data } = await axios.get(url);
  return data;
};
